<style lang="less">
.filter-container {
  height: 100vh;
  overflow-y: scroll;
  border-top: 1px solid #eeeeee;
}

.filter-container.padding {
  padding-bottom: 100px;
  background: #ffffff;
}

.city-box {
  display: flex;
  display: -webkit-flex;
  height: 100%;
}

.city-box .filter-city {
  width: 178px;
  overflow-y: scroll;
  background: #f7f7f7;
}
.city-box .filter-district {
  flex: 3;
  overflow-y: scroll;
  text-align: center;
}
.city-box .filter-district1 {
  flex: 4;
  overflow-y: scroll;
  text-align: center;
}

.city-box .city,
.city-box .district {
  height: 92px;
  line-height: 92px;
  color: #232c37;
  max-width: 220px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:0 24px;
  .select-img{
    width:28px;
    height: 20px;
  }
}

.city-box .city {
  overflow-y: scroll;
  text-align: center;
}
.city-box .district {
  padding: 0 40px;
}

.city-box .selected {
  color: #4169e1;
  background: #ffffff;
  border: none;
}
</style>
<template>
  <div class="filter-container">
    <div class="filter-condition city-box">
      <div class="city-list filter-city">
        <div class="city-list-item city" :class="tab==1?'selected':''" @click.stop="selectTab(1)">区域</div>
        <div class="city-list-item city" :class="tab==2?'selected':''" @click.stop="selectTab(2)">地铁</div>
      </div>
      <div class="city-list filter-district">
        <div
          class="city-list-item district"
          :class="selected==index?'selected':''"
          v-for="(item,index) in districtList"
          :key="index"
          @click.stop="selectCity('firstList',item,index,'1')"
        >{{item.name}}</div>
      </div>
      <div class="city-list filter-district1">
        <div
          v-if="districtList1.length>1"
          class="city-list-item district"
          :class="selected1==9999?'selected':''"
          @click.stop="selectCity('secondList','','9999','2')"
        >{{tab==1?'全部':'全线'}}</div>
        <div
          class="city-list-item district"
          :class="selected1==index?'selected':''"
          v-for="(item,index) in districtList1"
          :key="index"
          @click.stop="selectCity('secondList',item,index,'2')"
        >
          <label>{{item.name}}</label>
          <img class="select-img" v-if="selected1==index" src="../../assets/img/rectangle.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "screen",
  data() {
    return {
      tab: 1,
      districtList: [], //区域
      districtList1: [], //地铁
      selected: 0,
      selected1: -1,
      cityId: -1,
      allInfo: {},
      searchType:'area',
      subwayLineId:'',
      districtId:''
    };
  },
  created() {
    let options = this.$route.query;
    this.cityId = options.cityId;
    this.getFirstList(1, this.cityId, true);
  },
  mounted() {},
  methods: {
    selectCity(name, item, index) {
      if (name == "firstList") {
        this.selected = index;
        this.getSecondList(this.tab, item.value);
        this.allInfo = item;
        if (this.tab==1) {
          this.districtId = item.value;
        }else{
          this.subwayLineId = item.value;
        }
      } else {
        let model = {};
        if (index == 9999) {
          model = this.allInfo;
        }else{
          model = item;
        }
        if (!this.districtId&&this.tab==1) {
          this.districtId = this.allInfo.value;
        }
        this.selected1 = index;
        model.cityId = this.cityId;
        model.searchName = item.name;
        model.searchType = this.searchType;
        model.districtId = this.districtId;
        model.subwayLineId = this.subwayLineId;
        model.standType = 'stand'+this.selected1;
        model.lineType = 'line'+this.selected;
        localStorage.setItem("screen", JSON.stringify(model));
        this.isMiniProgram(res => {
          if (res) {
            wx.miniProgram.reLaunch({url: '/pages/home/index'});
          } else {
            this.$router.go(-1);          
          }
        });
      }
    },
    selectTab(e) {
      if (e==1) {
        this.searchType = 'area';
      }else{
        this.searchType = 'line';
      }
      this.selected = -1;
      this.selected1 = -1;
      if (e == this.tab) {
        return false;
      } else {
        this.districtList1 = [];
        this.tab = e;
        if (e == 1) {
          this.getFirstList(1, this.cityId);
        } else {
          this.getFirstList(2, this.cityId);
        }
      }
    },
    async getFirstList(type, cityId, isFirst) {
      if (type == 1) {
        await this.$axios
          .post("api/xz/area/list/", {
            cityId: cityId
          })
          .then(res => {
            if (res.success) {
              this.districtList = res.result;
              this.allInfo = this.districtList[0];
              if (isFirst) {
                this.getSecondList(1, this.districtList[0].value);
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        await this.$axios
          .post("api/xz/subwayline/list/", {
            cityId: cityId
          })
          .then(res => {
            if (res.success) {
              this.districtList = res.result;
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    async getSecondList(type, code) {
      if (type == 1) {
        await this.$axios
          .post("api/xz/zone/infolist/", {
            areaId: code
          })
          .then(res => {
            if (res.success) {
              this.districtList1 = res.result;
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        await this.$axios
          .post("api/xz/subwaysite/list/", {
            lineId: code
          })
          .then(res => {
            if (res.success) {
              this.districtList1 = res.result;
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/pages/screen/index.vue